import { useIsAdminArea } from "@/react/components/SettingsApp/CompassCompat/useIsAdminArea";

import {
  useCanvasPageTitleCrumb,
  useCanvasPageTitleGrandparentCrumb,
  useCanvasPageTitleParentCrumb,
} from "./CanvasHeaderContext";
import { useMemberBreadcrumb } from "./useMemberBreadcrumb";
import type { BreadcrumbCrumb } from "./useSettingsBreadcrumb";
import { useSettingsBreadcrumb } from "./useSettingsBreadcrumb";

export const useCanvasBreadcrumb = (): BreadcrumbCrumb[] => {
  const isAdminArea = useIsAdminArea();
  const settingsBreadcrumb = useSettingsBreadcrumb();
  const memberBreadcrumb = useMemberBreadcrumb();
  const pageTitleCrumb = useCanvasPageTitleCrumb();
  const pageTitleParentCrumb = useCanvasPageTitleParentCrumb();
  const pageTitleGrandparentCrumb = useCanvasPageTitleGrandparentCrumb();

  if (pageTitleCrumb) {
    if (pageTitleGrandparentCrumb && pageTitleParentCrumb) {
      return [pageTitleGrandparentCrumb, pageTitleParentCrumb, pageTitleCrumb];
    }
    return pageTitleParentCrumb
      ? [pageTitleParentCrumb, pageTitleCrumb]
      : [pageTitleCrumb];
  }

  return isAdminArea ? settingsBreadcrumb : memberBreadcrumb;
};
